import React from "react";
import './Checkbox.css'
import { useReadOnly } from "../../../utils/ReadOnlyContext";
import { getFormErrorByName, useFormErrorContext } from "../../../utils/context/FormErrorContext";

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface CheckboxProps extends React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> {
    checkboxclassname?: string,
    checkboxContainerClassName?: string
    hasErrors?: boolean,
    hasWarnings?: boolean,
    ariaLabel?: string,
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
}

export default function Checkbox(props: CheckboxProps): JSX.Element {
    const { isReadOnly } = useReadOnly()
    const { errors } = useFormErrorContext()
    
    
    return (
        <>
            <label className={`checkbox-container ${props.checkboxContainerClassName ?? ""}`} aria-label={props.ariaLabel ? props.ariaLabel : props.name}>
                <input type="checkbox" {...props}
                    onChange={props.onChange}
                    aria-label={props.ariaLabel ? props.ariaLabel : props.name}
                    disabled={isReadOnly || props.disabled} 
                    data-primary-key={getFormErrorByName(errors, props.name as string)?.primaryKey as string}
                    data-testid={(props.ariaLabel ? props.ariaLabel : props.name) + "-checkbox"}
                    />
                <span className={`checkmark ${props.checkboxclassname??""}${props.hasErrors ? " form-error" : ""}${props.hasWarnings ? " form-warning" : ""}`}></span>
            </label>
        </>
    )
}
